// extracted by mini-css-extract-plugin
module.exports = {"root":"ToDoList_root__3qvpj","header":"ToDoList_header__GDkE5","mainBlock":"ToDoList_mainBlock__2D7XO"};